export function checkUserName(user){
    if(user != null){
        return {
            lastname : user.lastname,
            firstname : user.firstname,
        }
    }

    return {
        firstname : 'Utilisateur',
        lastname : 'Supprimé',
    }
}